import { useMemo } from 'react';

import { getFilters } from 'utils/dashboard/utils';

import { FilterItem } from 'components/Dashboard/Filters/consts';

import { FilterName } from 'store/models/dashboard';
import { useSelector } from 'store/utils';

const useFilters = (): Record<FilterName, FilterItem[]> => {
    const trls = useSelector((state) => state.translations.trls);
    const filtersList = useSelector((state) => state.dashboard.filtersList);

    const filters: Record<FilterName, FilterItem[]> = useMemo(() => {
        return getFilters(trls, filtersList);
    }, [filtersList, trls]);

    return filters;
};

export default useFilters;
